import React from "react";
import { SettingsUpdate } from "./about-us";

const PrivacyPolicy = () => (
	<SettingsUpdate type={"policy"} title="Privacy Policy" />
);

export default PrivacyPolicy;
